import { render } from "./TyperAddSample.vue?vue&type=template&id=1d6284aa&scoped=true"
import script from "./TyperAddSample.vue?vue&type=script&lang=js"
export * from "./TyperAddSample.vue?vue&type=script&lang=js"

import "./TyperAddSample.vue?vue&type=style&index=0&id=1d6284aa&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6284aa"]])

export default __exports__